// @flow
import Cookies from 'js-cookie'
import stringify from 'json-stringify-safe'

import * as ids from '../constants/ids'
import * as types from '../constants/action_types'
import { getActiveTool } from '../components/geo_bar_panel'
import { onChangeInput } from './form'

export const onPostClickGeoBarItem = (id: string, state) =>
    ({ type: types.POST_CLICK_GEO_BAR_ITEM, id, state })

export const onClickGeoBarItem = (id: string) => (dispatch, getState) => {
    dispatch({ type: types.CLICK_GEO_BAR_ITEM, id })
    dispatch(onPostClickGeoBarItem(id, getState()))
}

export const onGeoBarChangeSearchValue = (value: string) =>
    ({ type: types.GEO_BAR_CHANGE_SEARCH_VALUE, value })

export const onGeoBarSuggestionsFetchRequested = (value: string) =>
    ({ type: types.GEO_BAR_SUGGESTIONS_FETCH_REQUESTED, value })

export const onGeoBarSelectTool = (tool: {}) =>
    ({ type: types.GEO_BAR_SELECT_TOOL, tool })

export const onGeoBarSuggestionsClearRequested = () =>
    ({ type: types.GEO_BAR_SUGGESTIONS_CLEAR_REQUESTED })

export const onGeoBarSelectLayer = (isSelected: boolean, layer, tool, opts = {}) =>
    ({ type: types.GEO_BAR_SELECT_LAYER, isSelected, layer, tool, opts })

export const setGeoBarFetchingOperation = (isFetching: boolean, id: string) =>
    ({ type: types.GEO_BAR_FETCHING_OPERATION, isFetching, id })

export const setGeoBarFetchedOperationError = (id: string, error) =>
    ({ type: types.FETCH_ERROR, id, error })

export const setGeoBarFetchedOperation = (result, id: string) =>
    ({ type: types.GEO_BAR_FETCHED_OPERATION, result, id })

export const onGeoBarSubmitIntersect = layers => (dispatch, getState) => {
    let fetchError = false
    // Save the result of the intersection to the map source of the
    // first layer.  Generally this should default to the user's user layers.
    const path = /(.*\/)(.*)/g.exec(layers[0].filepath)[1]
    const payload = {
        layers,
        saveResult: {
            path,
        },
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_INTERSECT))
        fetch('/er2_geoprocessing/api/v1/vector/intersect/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_INTERSECT))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_INTERSECT, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json, ids.GEO_BAR_INTERSECT))
            }
        })
    }
}

export const onGeoBarSubmitUnion = layers => (dispatch, getState) => {
    let fetchError = false
    // Save the result of the intersection to the map source of the
    // first layer.  Generally this should default to the user's user layers.
    const path = /(.*\/)(.*)/g.exec(layers[0].filepath)[1]
    const payload = {
        layers,
        saveResult: {
            path,
        },
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_UNION))
        fetch('/er2_geoprocessing/api/v1/vector/union/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_UNION))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_UNION, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json, ids.GEO_BAR_UNION))
            }
        })
    }
}

export const onGeoBarSubmitBuffer = (layer, distance, outputName, engine) => (dispatch, getState) => {
    let fetchError = false
    // Save the result of the intersection to the map source of the
    // first layer.  Generally this should default to the user's user layers.
    const path = /(.*\/)(.*)/g.exec(layer.filepath)[1]
    const payload = {
        distance,
        engine,
        layer,
        outputName,
        saveResult: {
            path,
        },
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_BUFFER))
        fetch('/er2_geoprocessing/api/v1/vector/buffer/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_BUFFER))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_BUFFER, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json, ids.GEO_BAR_BUFFER))
            }
        })
    }
}

export const onGeoBarSubmitDissolve = (layers, key) => (dispatch, getState) => {
    let fetchError = false
    // Save the result of the intersection to the map source of the
    // first layer.  Generally this should default to the user's user layers.
    const path = /(.*\/)(.*)/g.exec(layers[0].filepath)[1]
    const payload = {
        layers,
        key,
        saveResult: {
            path,
        },
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_DISSOLVE))
        fetch('/er2_geoprocessing/api/v1/vector/dissolve/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_DISSOLVE))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_DISSOLVE, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json, ids.GEO_BAR_DISSOLVE))
            }
        })
    }
}

export const onGeoBarSubmitClip = (targetLayer, boundaryLayer) => (dispatch, getState) => {
    let fetchError = false
    // Save the result of the intersection to the map source of the
    // first layer.  Generally this should default to the user's user layers.
    const path = /(.*\/)(.*)/g.exec(targetLayer.filepath)[1]
    const payload = {
        boundaryLayer,
        targetLayer,
        saveResult: {
            path,
        },
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_CLIP))
        fetch('/er2_geoprocessing/api/v1/vector/clip/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_CLIP))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_CLIP, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json, ids.GEO_BAR_CLIP))
            }
        })
    }
}

export const onGeoBarSubmitZonalStats = (targetLayer, boundaryLayer) => (dispatch, getState) => {
    let fetchError = false
    // Save the result of the intersection to the map source of the
    // first layer.  Generally this should default to the user's user layers.
    const path = /(.*\/)(.*)/g.exec(targetLayer.filepath)[1]
    const payload = {
        zonalLayers: [boundaryLayer],
        targetLayer,
        saveResult: {
            path,
        },
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_ZONAL_STATS))
        fetch('/er2_geoprocessing/api/v1/raster/stats/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_ZONAL_STATS))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_ZONAL_STATS, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json, ids.GEO_BAR_ZONAL_STATS))
            }
        })
    }
}

export const onGeoBarFetchClassifications = (targetLayer, classificationType, classificationCount) => (dispatch, getState) => {
    let fetchError = false
    // Save the result of the intersection to the map source of the
    // first layer.  Generally this should default to the user's user layers.
    const path = /(.*\/)(.*)/g.exec(targetLayer.filepath)[1]
    const payload = {
        raster: targetLayer,
        classificationType,
        classificationCount,
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_CLASSIFICATIONS))
        fetch('/er2_geoprocessing/api/v1/raster/classifications/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_CLASSIFICATIONS))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_CLASSIFICATIONS, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json.result, ids.GEO_BAR_CLASSIFICATIONS))
            }
        })
    }
}

export const prepareClassifications = (classifications) => {
    const result = []
    classifications.forEach((cls, idx) => {
        if (idx < classifications.length - 1) {
            result.push({
                start: cls,
                end: classifications[idx + 1],
                value: idx + 1,
            })
        }
    })
    return result
}

export const onGeoBarSubmitReclassify = (targetLayer, classifications) => (dispatch, getState) => {
    let fetchError = false
    const formattedClassifications = prepareClassifications(classifications)
    // Save the result of the intersection to the map source of the
    // first layer.  Generally this should default to the user's user layers.
    const path = /(.*\/)(.*)/g.exec(targetLayer.filepath)[1]
    const payload = {
        raster: targetLayer,
        remap: formattedClassifications,
        saveResult: {
            path,
        },
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_RECLASS))
        fetch('/er2_geoprocessing/api/v1/raster/reclass/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_RECLASS))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_RECLASS, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json.result, ids.GEO_BAR_RECLASS))
            }
        })
    }
}

export const onGeoBarSubmitCalculate = (layers, expression) => (dispatch, getState) => {
    let fetchError = false
    // Save the result of the intersection to the map source of the
    // first layer.  Generally this should default to the user's user layers.
    const path = /(.*\/)(.*)/g.exec(layers[0].filepath)[1]
    const payload = {
        rasters: layers,
        expression,
        saveResult: {
            path,
        },
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_CALCULATOR))
        fetch('/er2_geoprocessing/api/v1/raster/calc/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_CALCULATOR))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_CALCULATOR, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json.result, ids.GEO_BAR_CALCULATOR))
            }
        })
    }
}

export const onGeoBarSubmitDigitize = (geojson, layerName, path) => (dispatch, getState) => {
    let fetchError = false
    const payload = {
        geojson,
        layerName,
        path,
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetching) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_DIGITIZE))
        fetch('/er2_geoprocessing/api/v1/geojson/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_DIGITIZE))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_DIGITIZE, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json.result, ids.GEO_BAR_DIGITIZE))
            }
        })
    }
}

export const onGeoBarFetchKnownBoundaries = (boundary, boundaryType) => (dispatch, getState) => {
    let fetchError = false
    const payload = {
        extent: boundary,
        boundaryType,
    }
    const tool = getActiveTool(getState())
    if (!tool.isFetchingKnownBoundary) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_FETCH_KNOWN_BOUNDARIES))
        fetch('/er2_geoprocessing/api/v1/known-boundaries/', {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: stringify(payload),
        }).then((response) => {
            fetchError = !response.ok
            return response.json()
        }).then((json) => {
            dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_FETCH_KNOWN_BOUNDARIES))
            if (fetchError) {
                dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_FETCH_KNOWN_BOUNDARIES, json))
            } else {
                dispatch(setGeoBarFetchedOperation(json.items, ids.GEO_BAR_FETCH_KNOWN_BOUNDARIES))
            }
        })
    }
}

export const onGeoBarFetchKnownBoundary = (boundaryId, boundaryType) => (dispatch, getState) => {
    let fetchError = false
    const tool = getActiveTool(getState())
    dispatch(onChangeInput(boundaryId, ids.GEO_BAR_DIG_KNOWN_BOUNDARY))
    if (!tool.isFetchingKnownBoundary) {
        dispatch(setGeoBarFetchingOperation(true, ids.GEO_BAR_FETCH_KNOWN_BOUNDARY))
        fetch(`/er2_geoprocessing/api/v1/known-boundaries/${boundaryType}/${boundaryId}`)
            .then((response) => {
                fetchError = !response.ok
                return response.json()
            }).then((json) => {
                dispatch(setGeoBarFetchingOperation(false, ids.GEO_BAR_FETCH_KNOWN_BOUNDARY))
                if (fetchError) {
                    dispatch(setGeoBarFetchedOperationError(ids.GEO_BAR_FETCH_KNOWN_BOUNDARY, json))
                } else {
                    dispatch(setGeoBarFetchedOperation(json.geojson, ids.GEO_BAR_FETCH_KNOWN_BOUNDARY))
                }
            })
    }
}

export const onGeoBarResultRendered = (id: string) => (dispatch, getState) => {
    dispatch({ type: types.GEO_BAR_RESULT_RENDERED, id })
}

export const onGeoBarFetchErrorRendered = (id: string) =>
    ({ type: types.GEO_BAR_FETCH_ERROR_RENDERED, id })
